import { useMemo } from "react"

// Erster/letzter Timestep, den der GeoServer tatsächlich liefert (≈ Modelllauf-Abdeckung)
export function useWeatherDataRange(steps) {
  return useMemo(() => {
    let first = null
    let last = null
    for (const step of steps) {
      if (!step.selectable) continue
      const iso = step.sourceTimestamp ?? step.iso
      if (!first) first = iso
      last = iso
    }
    return [first, last]
  }, [steps])
}
